import {Injectable} from '@angular/core';
import {ApiRequestService} from './api-request.service';
import {AppConfig} from '../../app-config';
import {Observable, BehaviorSubject} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {Roles} from '../../pages/settings/roles/roles.model';
import {Vendor} from '../../pages/user-management/vendor/vendor.model';
import {VendorRequestParam} from './vendor.service';
import {AllRoles} from '../../pages/settings/allroles/allroles.model';


export interface RolesRequestParam {
    id: number;
    name: string;
}

@Injectable()
export class RolesService {

    constructor(private apiRequest: ApiRequestService,
                private appConfig: AppConfig) {
    }

    // fetch Roles
    getRoles(pageNumber: any, noOfRecords: any): Observable<any> {
        let params: HttpParams = new HttpParams();
        params = params.append('p', pageNumber);
        params = params.append('l', noOfRecords);
        return this.apiRequest.get(this.appConfig.role_url, params);
    }

    // fetch permission
    fetchPermissionsForRole(id: number): Observable<any> {
        return this.apiRequest.get(this.appConfig.role_url + '/' + id + '/permissions');
    }

    // assign permissions

    assignPermission(id: number, permission: number[]): Observable<any> {
        return this.apiRequest.post(this.appConfig.role_url + '/' + id + '/assign-permissions', permission);
    }
    // save role
    save(role: AllRoles): Observable<any> {
        const me = this;

        const bodyData: VendorRequestParam = <VendorRequestParam> {
            'name': role.name

        };

        const roleDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.post(this.appConfig.role_url, bodyData)
            .subscribe(jsonResp => {
                    let roleInfoReturn: RolesRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const role: AllRoles = jsonResp.data[0];

                        roleInfoReturn = <RolesRequestParam>{
                             'name': role.name
                        };

                    } else {
                        console.log('added:----:' + jsonResp.message);
                    }
                    roleDataSubject.next(roleInfoReturn);
                },
                err => {
                    console.log('added err:----:' + err);
                });

        return roleDataSubject;
    }
    // update role
    update(role: AllRoles, id: number): Observable<any> {
        const me = this;

        const bodyData = {
            'id': role.id,
            'name': role.name
        };

        const roleDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>([]); // Will use this BehaviorSubject to emit data that we want after ajax login attempt

        me.apiRequest.put(this.appConfig.role_url + '/' + id, bodyData)
            .subscribe(jsonResp => {
                    let roleInfoReturn: RolesRequestParam;
                    if (jsonResp !== undefined && jsonResp !== null && jsonResp.success === 'true' && jsonResp.data.length !== 0) {
                        const cc: AllRoles = jsonResp.data[0];
                        roleInfoReturn =  <RolesRequestParam> {
                            'id': cc.id,
                            'name': cc.name,
                        };

                    } else {
                        console.log('updated :----:' + jsonResp.message);
                    }
                    roleDataSubject.next(roleInfoReturn);
                },
                err => {
                    console.log('update  err:----:' + err);
                });

        return roleDataSubject;
    }

    deleteRole(id: number): Observable<any> {
        const me = this;
        return me.apiRequest.delete(this.appConfig.role_url + '/' + id);
    }

}
